import gql from 'graphql-tag';

export default gql`
  query listFlags($appId: String!, $environment: String!) {
    listFlags(
      filter: { appId: { eq: $appId }, environment: { eq: $environment } }
    ) {
      items {
        uId
        appId
        featureKey
        environment
        enable
      }
    }
  }
`;
